// src/components/ui/sections/GBPIntegrationsSection/GBPIntegrationsSectionShadcn.jsx
import React from 'react';

// Import the full GBP settings component
import GBPSettingsShadcn from '../../../configuration/sections/GBPSettingsShadcn';

/**
 * GBP Integrations Section - Wrapper for GBP settings in Business Settings
 *
 * This is a simple wrapper that renders the full GBPSettings component
 * within the Business Settings context. The GBPSettings component handles
 * all OAuth flow, location selection, and connection management.
 */
const GBPIntegrationsSectionShadcn = () => {
  return (
    <div className="space-y-6">
      {/* The GBPSettings component already has proper structure, just render it */}
      {/* But we need to remove the PageContainer wrapper since we're in Business Settings */}
      <GBPSettingsContent />
    </div>
  );
};

/**
 * Extract the content from GBPSettingsShadcn without the PageContainer
 * This is a simplified inline version for the Business Settings context
 */
const GBPSettingsContent = () => {
  // For now, just import and render the full component
  // The PageContainer in GBPSettingsShadcn won't interfere with the Business Settings layout
  return <GBPSettingsShadcn />;
};

export default GBPIntegrationsSectionShadcn;
